// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2o8B-","topBottomGutter":"Layout_topBottomGutter__K4dgu"};